const makes = [
    {
      "code": "",
      "description": "ACURA"
    },
    {
      "code": "BMW",
      "description": "BMW"
    },
    {
      "code": "BUIC",
      "description": "BUICK"
    },
    {
      "code": "",
      "description": "CADILLAC"
    },
    {
      "code": "",
      "description": "CHEVROLET"
    },
    {
      "code": "",
      "description": "CHRYSLER"
    },
    {
      "code":"DODG",
      "description":"DODGE"
    },
    {
      "code": "",
      "description": "FORD"
    },
    {
      "code": "",
      "description": "GENESIS"
    },
    {
      "code": "",
      "description": "GMC"
    },
    {
      "code": "",
      "description": "HONDA"
    },
    {
      "code": "",
      "description": "HYUNDAI"
    },
    {
      "code": "",
      "description": "INFINITI"
    },
    {
      "code": "",
      "description": "JAGUAR"
    },
    {
      "code": "",
      "description": "JEEP"
    },
    {
      "code": "",
      "description": "KIA"
    },
    {
      "code": "",
      "description": "LEXUS"
    },
    {
      "code": "",
      "description": "LINCOLN"
    },
    {
      "code": "",
      "description": "MAZDA"
    },
    {
      "code": "",
      "description": "MCLAREN AUTOMOTIVE"
    },
    {
      "code": "",
      "description": "MINI"
    },
    {
      "code": "",
      "description": "MITSUBISHI"
    },
    {
      "code": "",
      "description": "NISSAN"
    },
    {
      "code": "OLDS",
      "description": "OLDSMOBILE"
    },
    {
      "code": "",
      "description": "RAM"
    },
    {
      "code": "",
      "description": "SUBARU"
    },
    {
      "code": "",
      "description": "TOYOTA"
    },
    {
      "code": "",
      "description": "VOLKSWAGEN"
    },
    {
      "code": "",
      "description": "VOLVO"
    }
  ];


export default makes;



// WEBPACK FOOTER //
// ./src/data/vehicleMakes.js